var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smd-loader',{class:_vm.position,style:(_vm.computedStyles),attrs:{"image":_vm.$options.Logo}})}
var staticRenderFns = []

export { render, staticRenderFns }